import { render, staticRenderFns } from "./DocumentItemCardMinus.vue?vue&type=template&id=02400484&scoped=true"
import script from "./DocumentItemCardMinus.vue?vue&type=script&lang=js"
export * from "./DocumentItemCardMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02400484",
  null
  
)

export default component.exports